/** @jsx jsx */
import { jsx } from "theme-ui";
import Divider from "../../elements/divider";
import { Float } from "../../styles/animations";

interface AsteroidFieldProps {
  offset: number;
  factor?: number;
}

const AsteroidField = ({ offset, factor = 1.5 }: AsteroidFieldProps) => (
  <Divider speed={0.15} offset={offset} factor={factor} zIndex={8}>
    {Array.from({ length: 20 }, (_, i) => {
      const size = 3 + (i % 4) + Math.floor(i / 5) * 0.5;
      const opacity = 0.4 + (i % 4) * 0.15;
      const glowSize = 2 + (i % 3);
      const colors = [
        "rgba(255, 255, 255, ",
        "rgba(200, 220, 255, ",
        "rgba(255, 200, 150, ",
        "rgba(186, 85, 211, ",
      ];
      const color = colors[i % colors.length];

      return (
        <Float key={i}>
          <div
            sx={{
              position: "absolute",
              left: `${(i * 5.3 + 10) % 95}%`,
              top: `${(i * 7.7 + 15) % 85}%`,
              width: `${size}px`,
              height: `${size}px`,
              borderRadius: i % 3 === 0 ? "50%" : "30%",
              background: `${color}${opacity})`,
              boxShadow: `
                0 0 ${glowSize}px ${color}${opacity * 0.8}),
                0 0 ${glowSize * 2}px ${color}${opacity * 0.4})
              `,
              animationDelay: `${i * 0.35}s`,
              transform: `rotate(${i * 15}deg)`,
              transition: "transform 0.3s ease-out",
            }}
          />
        </Float>
      );
    })}
  </Divider>
);

export default AsteroidField;

